import React from 'react';
import './APS191.css';

const APS191 = () => {
    return (
        <div className="aps191-container">
            <div className="titleaps191">
                <a href="https://engineering.calendar.utoronto.ca/course/aps191h1" target="_blank" rel="noopener noreferrer">
                    <p>APS191: Intro to Engineering</p>
                </a>
            </div>
            <p>
                A seminar series that previews the core fields in Engineering. Each seminar will highlight one of the major areas of Engineering. The format will vary and may include application examples, challenges, case studies, career opportunities, etc. The seminar provides an opportunity to better understand the various Core 8 programs within the faculty and enable a more educated decision when selecting the program of choice for second year of study. This course is offered on a credit/no credit basis.
            </p>
            <p>
                I did not take notes for this course.
            </p>
        </div>
    );
};

export default APS191;